import api from './axios';

export const getImports = () => api.get('/imports/');
export const createImport = (formData) =>
  api.post('/imports/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const getExports = () => api.get('/exports/');
export const createExport = (data) => api.post('/exports/', data);
export const downloadExport = (id) =>
  api.get(`/exports/${id}/download/`, { responseType: 'blob' });